(() => {
  const init = root => {
    const video = root.querySelector('video');
    const toggle = root.querySelector('[data-video-toggle]');
    if (!video || !toggle || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let requestedPause = false;
    let playPending = false;
    let inView = true;
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.loop = true;
    video.autoplay = !reduced.matches;
    const sync = () => {
      toggle.textContent = video.paused ? 'Play' : 'Pause';
      toggle.setAttribute('aria-label', video.paused ? 'Play meal video' : 'Pause meal video');
    };
    const play = (fromGesture = false) => {
      if ((!fromGesture && playPending) || !video.paused) return;
      video.muted = true;
      playPending = true;
      const attempt = video.play();
      if (attempt && typeof attempt.then === 'function') {
        attempt.then(sync, sync).finally(() => { playPending = false; });
      } else {
        playPending = false;
        sync();
      }
    };
    const resume = () => {
      if (inView && !document.hidden && !requestedPause && !reduced.matches) play();
    };
    toggle.hidden = false;
    toggle.addEventListener('click', () => {
      if (video.paused) {
        requestedPause = false;
        if (video.ended) video.currentTime = 0;
        play(true);
      }
      else { requestedPause = true; video.pause(); }
    });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('loadeddata', resume);
    video.addEventListener('canplay', resume);
    // Safari can suspend an autoplay video when it leaves the viewport.
    const visibility = new IntersectionObserver(entries => {
      inView = entries.some(entry => entry.isIntersecting);
      if (inView) resume();
      else video.pause();
    }, { threshold: 0.05 });
    visibility.observe(video);
    // Play the original full video from beginning to end using native looping.
    // Retry on a real user gesture when the browser has blocked initial autoplay.
    const gestureResume = event => {
      // Let the explicit Play/Pause button handle its own tap exactly once.
      if (event.target instanceof Element && event.target.closest('[data-video-toggle]')) return;
      if (inView && !document.hidden && !requestedPause && !reduced.matches) play(true);
    };
    document.addEventListener('touchend', gestureResume, { passive: true });
    document.addEventListener('pointerup', gestureResume, { passive: true });
    document.addEventListener('keydown', gestureResume);
    window.addEventListener('focus', resume);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) video.pause();
      else resume();
    });
    window.addEventListener('pageshow', resume);
    reduced.addEventListener('change', () => {
      video.autoplay = !reduced.matches;
      if (reduced.matches) video.pause();
      else resume();
    });
    if (reduced.matches) video.pause();
    else resume();
    sync();
  };
  document.querySelectorAll('[data-order-entry]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-order-entry]').forEach(init));
})();
